import { useLang } from "../../i18n/LanguageContext";
import { industries } from "../../data/industries";
import { IMAGES } from "../../lib/constants";
import Reveal from "../shared/Reveal";

export const IndustriesSection = () => {
  const { t, lang } = useLang();

  return (
    <section className="relative py-20 md:py-32 overflow-hidden" data-testid="industries-section">
      <div className="absolute inset-0 -z-10">
        <img src={IMAGES.dubai} alt="" className="w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
        <Reveal variant="fade-up" className="max-w-2xl mb-14">
          <div className="text-xs mono-label text-cyan-400 mb-3">{t.industries.eyebrow}</div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-strong">
            {t.industries.title}
          </h2>
          <p className="mt-4 text-base text-mid leading-relaxed">{t.industries.subtitle}</p>
        </Reveal>

        <Reveal variant="scale" stagger={60} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {industries.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <div
                key={ind.key}
                data-testid={`industry-${ind.key}`}
                className="group glass rounded-xl p-5 flex flex-col items-start gap-3 hover:border-cyan-400/50 hover-lift transition-all"
              >
                <div className="w-10 h-10 rounded-lg bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center group-hover:bg-cyan-400/20 transition">
                  <Icon className="w-5 h-5 text-cyan-300" />
                </div>
                <div className="text-sm font-medium text-strong">{lang === "en" ? ind.en : ind.ar}</div>
                <div className="text-[10px] mono-label text-soft">0{i + 1}</div>
              </div>
            );
          })}
        </Reveal>
      </div>
    </section>
  );
};

export default IndustriesSection;
